module.exports = require("swa-bootstrap-corporate-landing-home-page/api-keys.corporate");